import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { format } from 'date-fns'

import { RootState } from 'shared/store/store'

type BalanceAndTransactionsState = {
  startPeriod: number
  endPeriod: number
  accountNumbers?: string[]
  department?: string[]
  balanceSearchString?: string | null
  transactionSearchString?: string | null
}

const currentPeriod = () => Number(format(new Date(), 'yyyyMM'))

export const initialState: BalanceAndTransactionsState = {
  startPeriod: Number(new Date().getFullYear() + '01'),
  endPeriod: currentPeriod(),
  accountNumbers: [],
  department: ['-999'],
  balanceSearchString: '',
  transactionSearchString: '',
}

const balanceAndTransactionsSlice = createSlice({
  name: 'balanceAndTransactions',
  initialState,
  reducers: {
    // add porps to chose if balance or transaction should be reset aswell
    resetBalanceAndTransactionsFilters: (
      state,
      action: PayloadAction<{ balance?: boolean; transaction?: boolean }>
    ) => {
      state.startPeriod = initialState.startPeriod
      state.endPeriod = initialState.endPeriod
      state.accountNumbers = initialState.accountNumbers
      state.department = initialState.department
      if (action.payload.balance) {
        state.balanceSearchString = initialState.balanceSearchString
      }
      if (action.payload.transaction) {
        state.transactionSearchString = initialState.transactionSearchString
      }
    },
    setStartPeriod: (state, action: PayloadAction<number>) => {
      state.startPeriod = action.payload
    },
    setEndPeriod: (state, action: PayloadAction<number>) => {
      state.endPeriod = action.payload
    },
    setAccountNumbers: (state, action: PayloadAction<string[]>) => {
      state.accountNumbers = action.payload
    },
    setDepartment: (state, action: PayloadAction<string[]>) => {
      state.department = action.payload
    },
    removeAccountNo: (state) => {
      state.accountNumbers = []
    },
    setBalanceAndTransactionsFilters: (
      state,
      action: PayloadAction<BalanceAndTransactionsState>
    ) => {
      state.startPeriod = action.payload.startPeriod
      state.endPeriod = action.payload.endPeriod
      state.accountNumbers = action.payload.accountNumbers
      state.department = action.payload.department
      state.balanceSearchString = action.payload.balanceSearchString
      state.transactionSearchString = action.payload.transactionSearchString
    },
    setBalanceSearchString: (state, action: PayloadAction<string | null>) => {
      state.balanceSearchString = action.payload
    },
    setTransactionSearchString: (
      state,
      action: PayloadAction<string | null>
    ) => {
      state.transactionSearchString = action.payload
    },
  },
})

export const {
  setStartPeriod,
  setEndPeriod,
  setAccountNumbers,
  setBalanceAndTransactionsFilters,
  setDepartment,
  setBalanceSearchString,
  setTransactionSearchString,
  resetBalanceAndTransactionsFilters,
} = balanceAndTransactionsSlice.actions

export default balanceAndTransactionsSlice

export const getBalanceSearchString = (state: RootState) =>
  state.balanceAndTransactions.balanceSearchString

export const getTransactionSearchString = (state: RootState) =>
  state.balanceAndTransactions.transactionSearchString

export const getStartPeriod = (state: RootState) =>
  state.balanceAndTransactions.startPeriod

export const getEndPeriod = (state: RootState) =>
  state.balanceAndTransactions.endPeriod

export const getAccountNumbers = (state: RootState) =>
  state.balanceAndTransactions.accountNumbers

export const getDepartment = (state: RootState) =>
  state.balanceAndTransactions.department

export const getBalanceAndTransactionsFilters = (state: RootState) => {
  return state.balanceAndTransactions
}
